<template>

    <header id="header" class="navbar navbar-dark sticky-top flex-md-nowrap child">
        <a id="logo-link" class="navbar-brand col-md-3 col-lg-2 me-0" href="/">
            <img id="logo-1" src="/themes/web/assets/images/logo.png" alt="">
        </a>

        <div class="container">
            <div class="header-content">
                <div class="header-avatar-body">
                    <div class="header-avatar">
                        <div class="account-menu account-menu-2">
                            <ul class="nav nav-pills" v-if="child_account">
                                <li class="nav-item nav-item-parent-avatar dropdown">
                                    <div class="nav-link dropdown-toggle">
                                        <div class="d-flex">
                                            <div class="thumb">
                                                <div class="thumb-content">
                                                    <img class="avatar" :src="child_account.avatar_url" alt="" v-if="child_account.avatar_url"/>
                                                    <img src="/themes/web/assets/images/avatar-default-2.svg" alt="" class="avatar" v-else>
                                                </div>

                                                <img v-if="child_account.emoji_url" class="emotion" :src="child_account.emoji_url" alt=""/>
                                            </div>
                                            <div>
                                                <div>{{child_account.fullname || child_account.username}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%;height: 100%;position: absolute;"/>
                                    <ul class="dropdown-menu" v-if="user.childrens" style="margin-top:31px">
                                        <li v-for="(u, index) in user.childrens" :class="getClassChildrent(u, index)" v-bind:key="index">
                                            <div class="d-flex">
                                                <!-- <div class="header-menu-item-border d-flex" @click="user.childrens.length > 1 ? showSelectChildrentAccountForm(u) : selectChildrent(u)"> -->
                                                <div class="header-menu-item-border d-flex" @click="showSelectChildrentAccountForm(u)">
                                                    <div class="thumb">
                                                        <div class="thumb-content">
                                                            <img class="avatar" :src="u.avatar_url" alt="" v-if="u.avatar_url"/>
                                                            <img class="avatar" src="/themes/web/assets/images/avatar-default-2.svg" alt="" v-else/>
                                                        </div>
                                                        <img v-if="u.emoji_url" class="emotion" :src="u.emoji_url" alt=""/>
                                                    </div>
                                                    <div>{{u.fullname || u.username}}</div>
                                                </div>
                                                <div>
                                                    <a href="#" @click = "showRemoveChildrentAccountForm(u)">
                                                        <i class="lisa-icon-search-close-1"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-if="user.childrens.length < 2" style="margin-bottom: 0; padding: 0;">
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li class="add-account" v-if="user.childrens.length < 2">
                                            <a href="/connect-account-home">
                                                <i class="lisa-icon-add-account"></i> {{$t('lisa_web_add_another_account')}}
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item" v-if="child_account.grade">
                                    <div class="nav-link">
                                        <button class="btn btn-htool">
                                            <i class="lisa-icon-header-grade"></i> {{ child_account.grade }}
                                        </button>
                                    </div>
                                </li>
                            </ul>
                            <div v-else class="connect-account">
                                <div class="nav-item connect-account" >
                                    <a class="" href="/connect-account" @click.native="getSoundClick">
                                        <div class="d-flex">
                                            <img class="icon-info-right" src="/themes/ito/images/icons/icon-save-account.svg">
                                            <div class="label" style="font-weight: 800; font-size: 16px; color: #ffffff; margin-left: 8px">{{$t('p_connect_account_btn')}}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header-info">
                    <div class="header-avatar-body">
                        <div class="header-avatar">
                            <div class="account-menu">
                                <ul class="nav nav-pills">
                                    <li class="nav-item dropdown">
                                        <a class="" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                                            <div class="d-flex">
                                                <div class="thumb" style="width: 44px;">
                                                    <div class="thumb-content">
                                                        <img class="avatar" :src="user.avatar_url" alt="" v-if="user.avatar_url" />
                                                        <!-- <img class="avatar" src="/themes/web/assets/images/avatar.svg" alt="" /> -->
                                                    </div>
                                                </div>
                                                <div>
                                                    <span style="color: #000;">{{user.fullname || user.username}}</span>
                                                </div>
                                            </div>
                                        </a>
                                        <div class="temp1" style="width: 200px; height: 50px; position: absolute;"></div>
                                        <ul class="dropdown-menu" style="width: 180px;">
                                            <!-- <li>
                                                <a class="dropdown-item" href="/faq">
                                                    <i class="lisa-icon-account-help"></i> <span>{{$t('help')}}</span>
                                                </a>
                                            </li> -->
                                            <li>
                                                <a class="dropdown-item" @click="onLogout">
                                                    <i class="lisa-icon-account-logout"></i> <span>{{$t('logout')}}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="header-help">
            <a href="/faq">
                <button class="btn btn-help">
                    <i class="lisa-icon-header-help"></i> {{$t('help')}}
                </button>
            </a>
        </div> -->

        <div class="modal fade modal-flex" id="removeAccountModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="removeAccountModal" aria-hidden="true">
            <div class="modal-dialog" style="width: 400px; max-width: 400px;">
                <div class="modal-content popup-confirm" style="padding-bottom: 15px;">
                    <div class="modal-header">
                        <h5 class="modal-title text-red" id="staticBackdropLabel">{{$t('p_remove_child_title')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="welcome-back">
                            <div class="welcome-back-content">
                                {{$t('lisa_web_remove_children_account_confirm', {account_name: account_selecting_remove.fullname?account_selecting_remove.fullname:account_selecting_remove.username})}}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="justify-content: center;">
                        <button type="button" class="btn btn-confirm-no" style="padding: 8px 20px; margin-right: 50px;" data-bs-dismiss="modal" aria-label="Close">{{$t('no')}}</button>
                        <button type="button" class="btn btn-confirm" style="padding: 8px 20px;" @click="removeChildrentAccount(account_selecting_remove)">{{$t('yes')}}</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade modal-flex" id="selectAccountModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="removeAccountModal" aria-hidden="true">
            <div class="modal-dialog" style="width: 400px; max-width: 400px;">
                <div class="modal-content popup-confirm" style="padding-bottom: 15px;">
                    <div class="modal-header">
                        <h5 class="modal-title text-red" id="staticBackdropLabel">{{$t('p_switch_child_title')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="welcome-back">
                            <div class="welcome-back-content">
                                {{$t('lisa_web_follow_children_account_confirm', {account_name: account_selecting_follow.fullname?account_selecting_follow.fullname:account_selecting_follow.username})}}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="justify-content: center;">
                        <button type="button" class="btn btn-confirm-no" style="padding: 8px 20px; margin-right: 50px;" data-bs-dismiss="modal" aria-label="Close">{{$t('no')}}</button>
                        <button type="button" class="btn btn-confirm" style="padding: 8px 20px;" @click="selectChildrent(account_selecting_follow)">{{$t('yes')}}</button>
                    </div>
                </div>
            </div>
        </div>

    </header>


</template>

<script>
    import axios from 'axios'
    import {mapGetters} from 'vuex'
    import {getParentProfile} from '../models/profile'
    import {removeChild} from '../models/parent'
    import { getConfigs, getLanguage, soundClick } from "../utils/utils";

    export default {
        name: "NavBarParent",

        data() {
            const configs = getConfigs();
            const locate = getLanguage();
            const localizes = configs.localize || [];
            const user_info = this.$store.state.user_info;

            let locate_info = {};
            localizes.forEach(item => {
                if(item.lang == locate){
                    locate_info = item;
                }
            });

            let child_account = localStorage.getItem('child_account');

            child_account = child_account?JSON.parse(child_account):null;

            if(child_account == null && user_info.childrens){
                child_account = user_info.childrens[0];
            }

            console.log('child_account', child_account);
            
            return {
                locate: getLanguage(),
                locate_info: locate_info,
                configs: configs,
                localizes: localizes,
                account_selecting_remove: {},
                account_selecting_follow: {},
                child_account: child_account,
            };
        },

        computed: {
            user() {
                return this.$store.state.user_info;
            },
        },

        created() {
            this.fetch();
        },
        methods: {
            async fetch(){
                await axios.all([
                    getParentProfile({
                        notification_id: window.localStorage.getItem('firebaseToken'),
                        type_code: 'web'
                    })
                ]).then(axios.spread(({data}) => {
                    this.$store.commit("setLoading", false);

                    this.$store.commit("SET_LAYOUT", 'parent-layout');

                    if (data.code != 0) {
                        localStorage.removeItem('is_login');
                        localStorage.removeItem('grade');
                        localStorage.removeItem("child_account");

                        window.location.href = "/login";

                        return;
                    }

                    const user_info = data.results;

                    console.log('parent: ', user_info);
                    user_info.avatar_url = user_info.avatar_url || '/themes/web/assets/images/avatar-default-2.svg';

                    this.$store.commit("SET_USER_INFO", user_info);
                })).catch(error => {
                    //commit("SET_LAYOUT", 'app-layout');
                    this.$store.commit('logout');

                    //window.location.href = "/login"
                });
            },

            selectChildrent(user){
                localStorage.setItem('child_account', JSON.stringify(user));

                // location.reload();
                // this.$router.push({
                //     path: "/",
                // });
                window.location.href = '/'
            },

            getClassChildrent(user, index){
                if((this.child_account && this.child_account.id == user.id) || (index == 0 && this.child_account == null)){
                    return "active";
                }

                return "";
            },

            showRemoveChildrentAccountForm(account){
                this.account_selecting_remove = account;

                $('#removeAccountModal').modal('show');
            },

            showSelectChildrentAccountForm(account){
                if(window.location.pathname == '/connect-account' || window.location.pathname == '/connect-account-home') {
                    window.location.href = '/'
                }else{
                    this.account_selecting_follow = account;
                    if(this.child_account.id != this.account_selecting_follow.id){
                        $('#selectAccountModal').modal('show');
                    }
                }
            },

            removeChildrentAccount(account) {
                const that = this;

                removeChild({
                    children_id: account.id,
                    parent_id: this.user.id,
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    //that.user_info.avatar_id = response.data.results.childrens;

                    $('#removeAccountModal').modal('hide');

                    localStorage.removeItem('child_account');

                    location.reload();
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });                
            },

            onLogout(e) {
                this.$store.dispatch('logout').then(() => {
                    localStorage.removeItem('is_login');
                    localStorage.removeItem('grade');
                    localStorage.removeItem("child_account");
                    window.location.href = "/login";
                });
                // localStorage.removeItem('grade');
                e.preventDefault();
            },

            getSoundClick() {
                soundClick();
            },
        }
    }
</script>

<style scoped>
    .nav-item-parent-avatar{
        box-shadow: none;
        border: 1px solid #CCD2E3;
    }
    #nav-bar{
        justify-content: space-between;
        align-items: center;
    }
    .help-button {
        background: linear-gradient(180deg, #20C997 0%, #28A745 100%);
        color: #ffffff;
        width: 130px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231,231,231,0.25);
        margin-right: 20px;
    }
    .dropdown-menu .dropdown-item{
        color: #212529;
        cursor: pointer;
    }

    #header .account-menu .dropdown-menu {
        margin-top: 23px;
    }

    .connect-account{
        background: linear-gradient(180deg, #40C0F6 0%, #28B5F0 100%);
        box-shadow: 4px 2px 20px rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        display: flex;
        width: 260px ;
        padding: 0 12px;
        display: flex;
        justify-content: center;
        height: 40px;
        align-items: center;
    }
    .btn-htool{
        cursor: default !important;
    }
    .dropdown{
        cursor: pointer;
    }
    .dropdown:hover .dropdown-menu{
        display: block;
    }
    .temp1:hover .dropdown-menu{
        display: block;
    }
    #logo-1{
        /* height: 115px; */
        width: 100%;
    }
    .btn.btn-htool{
        border: 1px solid #CCD2E3;
        box-shadow: none;
    }
</style>
